import React, { Component } from 'react';
import translate from 'app/translations';
import PropTypes from 'prop-types';
import { getApiUrl } from 'app/apiClient';
import isBackOffice from 'utils/appUtils';
import {
  Table, Button, Modal,
} from 'antd';
import moment from 'moment';
import autobind from 'react-autobind';
import AgentProfilePropType from '../AgentProfilePropType';


export class DocumentTable extends Component {
  constructor(props) {
    super(props);
    this.t = translate;
    autobind(this);
    this.state = {
      showDeleteDocumentModal: false,
      targetDocument: null,
    };
  }

  getEnumDisplayName(key, enums = []) {
    const targetEnum = enums.find(e => e.value === key);
    return targetEnum ? targetEnum.name : '';
  }

  loadDeleteDocument(e, document) {
    e.preventDefault();
    this.setState({
      showDeleteDocumentModal: true,
      targetDocument: document,
    });
  }

  cancelDeleteDocument() {
    this.setState({
      showDeleteDocumentModal: false,
      targetDocument: null,
    });
  }

  deleteDocument() {
    this.props.onDeleteDocument(this.state.targetDocument.id);
    this.cancelDeleteDocument();
  }

  sortDocumentsByUtcDate(documentList) {
    return documentList.sort((docA, docB) => moment.utc(docB.uploadDate).diff(moment.utc(docA.uploadDate)));
  }

  render() {
    const {
      documentList,
    } = this.props;

    const { isCallInprogress } = this.props.agentProfile;

    const columns = [
      {
        title: this.t('DocumentTable.docType'),
        dataIndex: 'type',
        key: 'type',
        render: data => (<span>{this.getEnumDisplayName(data, this.props.documentTypes)}</span>),
      },
      {
        title: this.t('EandO.fileName'),
        dataIndex: 'filename',
        key: 'filename',
        render: (_, record) => (
          <div>
            {isBackOffice ? (
              <Button
                onClick={() => { window.open(`${getApiUrl()}/back-office/download-document/${record.id}`); }}
                className="ant-active-blue btn-link"
                type="button"
              >
                {record.filename}
              </Button>
            ) : record.filename}
          </div>
        ),
      },
      {
        title: this.t('EandO.dateProvided'),
        dataIndex: 'uploadDate',
        key: 'uploadDate',
        align: 'right',
        className: 'desktop-only',
        render: data => (<span>{moment(data).format('MMM D, YYYY')}</span>),
      },
      {
        dataIndex: 'deleteDocuments',
        key: 'deleteDocuments',
        align: 'center',
        width: 30,
        render: (_, record) => (
          <div>
            <Button
              icon="close-circle"
              type="danger"
              size="small"
              title={this.t('Generic.delete')}
              disabled={isCallInprogress}
              onClick={e => this.loadDeleteDocument(e, record)}
            />
          </div>
        ),
      },
    ];

    return (
      <div>
        <Table
          className="border no-pagination"
          style={{ borderRadius: 4 }}
          pagination={false}
          columns={columns}
          rowKey="id"
          dataSource={this.sortDocumentsByUtcDate(documentList || [])}
        />
        <Modal
          title={this.t('DocumentTable.modalDelete.title')}
          visible={this.state.showDeleteDocumentModal}
          onOk={() => { this.deleteDocument(); }}
          onCancel={() => { this.cancelDeleteDocument(); }}
          okText={this.t('DocumentTable.modalDelete.ok')}
          cancelText={this.t('DocumentTable.modalDelete.cancel')}
          closable={false}
          maskClosable={false}
        >
          {this.state.targetDocument && this.state.targetDocument.filename && (
            <span>
              {
                this.t(
                  'DocumentTable.modalDelete.body',
                  {
                    docName: this.state.targetDocument.filename,
                    uploadDate: moment(this.state.targetDocument.uploadDate).format('MMM D, YYYY'),
                  },
                )
              }
            </span>
          )}
        </Modal>
      </div>
    );
  }
}

DocumentTable.propTypes = {
  agentProfile: PropTypes.shape(AgentProfilePropType).isRequired,
  documentList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    filename: PropTypes.string,
    type: PropTypes.string,
    uploadDate: PropTypes.string,
  })).isRequired,
  documentTypes: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    name: PropTypes.string,
  })).isRequired,
  onDeleteDocument: PropTypes.func.isRequired,
};

export default DocumentTable;
